import { httpGet } from 'giro-react-toolkit/source/UtilityFunctions/Ajax';

/**
 * The MetroCloudAlliance geocoding service
 */
class MetroCloudAllianceGeocoding {
   /**
    * Get a place latitude/longitude and name based on some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The geocode request promise object.
    */
   geocode(options, abortController, callbackFct) {
      const url = reachMap.geocodingOptions.geocode.clientUrl;
      let mapbounds = null;

      if (options.mapbounds &&
         options.mapbounds.length === 2 &&
         options.mapbounds[0].latitude && options.mapbounds[0].longitude &&
         options.mapbounds[1].latitude && options.mapbounds[1].longitude) {
                             // The mapbox geocoding bounds format is minX,minY,maxX,maxY
         mapbounds = `${options.mapbounds[0].longitude},${options.mapbounds[0].latitude},${options.mapbounds[1].longitude},${options.mapbounds[1].latitude}`;
      }

      let params = {
         api_key: reachMap.geocodingOptions.accessToken,
         query: options.query,
         numberofresults: options.limit,
         limitbybounds: options.limitbybounds
      };

      if (mapbounds)
         params.mapbounds = mapbounds;

      var signal = abortController ? abortController.signal: null;

      const geocodePromise = httpGet(url, { params, fetchOptions: { signal } });

      geocodePromise.then(response => {
         if (response.ok)
            return (response.json());
         else
            throw new Error('Status code:' + response.statusText + '- Failed to geocode the place - ' + JSON.stringify(options));
      }).then(response => {
         if (!(response && response.results))
            callbackFct([]);

                              // Les lat/long retournés par l'api sont souvent des chaines de caractères.
                              // On utilise parseFloat pour les convertir tous en nombre flottant.
                              // Exemple de resultats avec lat/long en chaines de caractères:
                              // http://api.metrocloudalliance.com/search/?query=LAX&minifyresult=false&numberofresults=50&mapbounds=33.989,-118.541,34.045,-118.459
         var data = response.results.filter(p => p.description.length > 0)
            .map((place) => {
               return ({
                  placeName: place.description,
                  latitude: parseFloat(place.lat),
                  longitude: parseFloat(place.lng)
               });
            });

         callbackFct(data);
      }).catch((error) => {
         if (error.name !== 'AbortError') {
            callbackFct([], error);
         }
      });

      return (geocodePromise);
   }
   /**
    * Search a location using the latitude/longitude and some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The reverse request promise object.
    */
   reverse(options, abortController, callbackFct) {
      const url = reachMap.geocodingOptions.reverse.clientUrl;

      let params = {
         api_key: reachMap.geocodingOptions.accessToken,
         lat: options.latitude,
         lng: options.longitude,
         numberofresults: options.limit,
         searchtype: options.types
      };

      var signal = abortController ? abortController.signal : null;

      const reversePromise = httpGet(url, {params, fetchOptions:{signal}});

      reversePromise.then(response => {
         if (response.ok)
            return (response.json());
         else
            throw new Error('Status code:' + response.statusText + '- Failed to find the place - ' + JSON.stringify(options));
      }).then(response => {
         if (!(response && response.length))
            callbackFct([]);

                              // Les lat/long retournés par l'api sont souvent des chaines de caractères.
                              // On utilise parseFloat pour les convertir tous en nombre flottant.
                              // Exemple de resultats avec lat/long en chaines de caractères:
                              // http://api.metrocloudalliance.com/search/?query=LAX&minifyresult=false&numberofresults=50&mapbounds=33.989,-118.541,34.045,-118.459
         var data = response.filter(p => p.display_name.length > 0)
            .map((place) => {
               return ({
                  placeName: place.display_name,
                  latitude: parseFloat(place.lat),
                  longitude: parseFloat(place.lng)
               });
            });

         callbackFct(data);
      }).catch((error) => {
         if (error.name !== 'AbortError') {
            callbackFct([], error);
         }
      });

      return (reversePromise);
   }
}

export default MetroCloudAllianceGeocoding;
